module.exports = __webpack_public_path__ + "img/Marque_places_de_mariage.ed81361.jpg";